export const objectAssociationYaml = () => `objectAssociations: {}`;
export const objectAssociationItemYaml = () => `puller:
  id: 
  resultKey: items
  priority: 999
pusher: 
bulkPusher: 
table:
  id: `;
